/**
 * Calendar Event Content Component
 *
 * Custom event renderer for FullCalendar events.
 */

import type { EventContentArg } from '@fullcalendar/core';
import { CalendarDays, CheckSquare } from 'lucide-react';
import type { CalendarEventType } from '../types';

interface CalendarEventContentProps {
  eventInfo: EventContentArg;
}

export function CalendarEventContent({ eventInfo }: CalendarEventContentProps) {
  const { event } = eventInfo;
  const eventType = event.extendedProps.type as CalendarEventType;

  // Get appropriate icon (project or task)
  const Icon = eventType === 'task' ? CheckSquare : CalendarDays;

  return (
    <div className="flex items-center gap-1 px-1 py-0.5 overflow-hidden w-full">
      <Icon className="h-3 w-3 flex-shrink-0" />
      <span className="truncate text-xs font-medium">{event.title}</span>
    </div>
  );
}

/**
 * Render function for FullCalendar eventContent prop
 */
export function renderEventContent(eventInfo: EventContentArg) {
  return <CalendarEventContent eventInfo={eventInfo} />;
}
